module.exports = __webpack_public_path__ + "static/media/mec_logo.f2e70403.png";